export const IconPencil = ({ ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fillRule="evenodd"
      clipRule="evenodd"
      viewBox="0 0 24 24"
      width="1em"
      height="1em"
      {...props}
    >
      <path d="M14.536 3.808a3 3 0 0 1 4.242 0l1.414 1.414a3 3 0 0 1 0 4.242L9.8 19.857a1 1 0 0 1-.511.274l-5.303 1.06a1 1 0 0 1-1.177-1.177l1.06-5.303a1 1 0 0 1 .274-.51zm2.828 1.414 1.414 1.414a1 1 0 0 1 0 1.414l-1.414 1.414-2.828-2.828 1.414-1.414a1 1 0 0 1 1.414 0M13.121 8.05l-7.35 7.35-.707 3.536 3.536-.707 7.35-7.35z" />
    </svg>
  );
};
